export default "__VITE_ASSET__CrtFdYId__"